import React from "react";
import moment from 'moment';
import { component_tool } from "@/tool";
let { WizModal } = component_tool;
//配置项
let componentName = 'proKnowledgeType';
let ref;
const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD') : '';
};
const columns = [
  {
    name: "id",
    formItem: {
      type: "hidden"
    }
  },
  {
    title: "知识类型",
    name: "title",
    tableItem: {
      width: 200,
    },
    searchItem: {}
  },
  {
    title: "内容形式",
    name: "contentType",
    dict: [
      { code: 1, codeName: "文件上传" },
      { code: 2, codeName: "富文本框" },
      { code: 3, codeName: "关联业务" },
    ],
    searchItem: {
      type: "select"
    },
  },
  {
    title: "内容形式",
    name: "contentTypeStr",
    tableItem: {
    },
  },
  {
    title: "支持文件格式",
    name: "fileType",
    dict: [
      { code: 1, codeName: "PDF" },
      { code: 2, codeName: "DOC" },
      { code: 3, codeName: "DOCX" },
      { code: 4, codeName: "XLS" },
      { code: 5, codeName: "XLSX" },
      { code: 6, codeName: "PPT" },
      { code: 7, codeName: "PPTX" },
      { code: 8, codeName: "MP4" },
      // { code: 9, codeName: "MOV" },
      // { code: 10, codeName: "RM" },
      // { code: 11, codeName: "MPG" },
      // { code: 12, codeName: "AVI" },
    ],
    searchItem: {
      type: "select"
    },
  },
  {
    title: "支持文件格式",
    name: "fileTypeStr",
    tableItem: {
      width: 200,
    }
  },
  {
    title: "前端列表",
    name: "displayType",
    dict: [
      { code: 1, codeName: "文字列表" },
      { code: 2, codeName: "图文列表(左图右文)" },
      { code: 3, codeName: "图文列表(上图下文)" },
    ],
    searchItem: {
      type: "select"
    },
  },
  {
    title: "前端列表",
    name: "displayTypeStr",
    tableItem: {
    }
  },
  {
    title: "备注",
    name: "mark",
    tableItem: {
    }
  },
  {
    title: "状态",
    name: "state",
    dict: [
      { code: 0, codeName: "禁用" },
      { code: 1, codeName: "启用" },
    ],
    tableItem: {
    },
    searchItem: {
      type: "select"
    }
  },
];

const templateConfig = {
  mainProps: {},
  content: {
    name: "WizTableList",
    params: {
      columns,
      searchBarProps: {
        buttonSort: ['add', 'export','delete'],
        buttons: [
          {
            key: 'add',
            custom: true,
            params: { icon: 'plus', children: '新增', type: 'primary'},
            customOnClick: {
              key: 'jumpPage',
              params: {
                key: 'push',
                pathname: '/proKnowledge/knowledgeTypeList/add'
              }
            }
          },
          {
            key: "export",
            custom: true,
            params: { icon: 'export', children: '导出', type: 'export' },
            customOnClick: {
              key: "action",
              params: {
                apiKey: "export",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                return { ...filters }
              }
            }
          }
        ]
      },
      modalFormProps: {
        key: "modal123",
        params: {
          modalParams: {
            title: "Modal",
            children: "Bla bla123 .."
          }
        }
      },
      dataTableProps: {
        rowKey: "id",
        // selectType: "checkbox",
        isScroll: true,
        bordered: false,
        paging: false,
        loading: false,
      },
      rowOperateSort: ['update', 'enableOrDisable'],
      rowOperateView: [
        {
          key: "enableOrDisable",
          custom: true,
          params: { children: "发布"},
          textFormat: {
            recordKey: 'state',
            dirt: { 1: '禁用', 0: '启用' }
          },
          customOnClick: {
            key: "action",
            params: {
              apiKey: "updateState",
              apiParams: {}
            },
            formatParams: (rows, record, filters, callback) => {
              let statusNameStr = record['update'] === 0 ? "启用" : "禁用";
              const content = `您确定要` + statusNameStr + `该知识类型？`;
              WizModal.confirm({
                title: '注意', content,
                onOk: () => {
                  callback && callback({
                    state: record['state'] === 0 ? 1 : 0,
                    id: record['id']
                  })
                },
                onCancel() {
                }
              });
              return null
            }
          }
        },
        {
          key: "update",
          custom: true,
          params: { children: "编辑"},
          customOnClick: {
            key: "jumpPage",
            params: {
              key: "push",
              pathname: '/proKnowledge/knowledgeTypeList/update'
            }
          }
        }
      ],
      commonOperate: {
        add: true,
        delete: false,
        update: true

      }
    }
  }
};

const apis = {
  list: {
    path: `${componentName}/pageList`,
    payload: {
      key: `${componentName}@pageList`,
      apiParams: { pageNum: 1, pageSize: 10 }
    }
  },
  add: {
    path: `${componentName}/add`,
    payload: {
      key: `${componentName}@add`,
      apiParams: {}
    }
  },
  update: {
    path: `${componentName}/update`,
    payload: {
      key: `${componentName}@update`,
      apiParams: {}
    }
  },
  delete: {
    path: `${componentName}/delete`,
    payload: {
      key: `${componentName}@delete`,
      apiParams: {}
    }
  },
  updateState: {
    path: `${componentName}/updateState`,
    payload: {
      key: `${componentName}@updateState`,
      apiParams: {}
    }
  },
  export: {
    path: `${componentName}/export`,
    payload: {
      key: `${componentName}@export`,
      apiParams: {}
    }
  }
}


let reduxTemplateConfig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export { reduxTemplateConfig, templateConfig };
